import { render } from "./DetalleVendedor.vue?vue&type=template&id=582de457"
import script from "./DetalleVendedor.vue?vue&type=script&lang=js"
export * from "./DetalleVendedor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__